var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 46C34.5 47.1046 33.6046 48 32.5 48C31.3954 48 30.5 47.1046 30.5 46V30.8284L25.9142 35.4142C25.1332 36.1953 23.8668 36.1953 23.0858 35.4142C22.3047 34.6332 22.3047 33.3668 23.0858 32.5858L31.0858 24.5858C31.8668 23.8047 33.1332 23.8047 33.9142 24.5858L41.9142 32.5858C42.6953 33.3668 42.6953 34.6332 41.9142 35.4142C41.1332 36.1953 39.8668 36.1953 39.0858 35.4142L34.5 30.8284V46Z",
    fill: "#E02527"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 56V18L38.5 0H16.5C12.0817 0 8.5 3.58172 8.5 8V56C8.5 60.4183 12.0817 64 16.5 64H48.5C52.9183 64 56.5 60.4183 56.5 56ZM38.5 12C38.5 15.3137 41.1863 18 44.5 18H52.5V56C52.5 58.2091 50.7091 60 48.5 60H16.5C14.2909 60 12.5 58.2091 12.5 56V8C12.5 5.79086 14.2909 4 16.5 4H38.5V12Z",
    fill: "#E02527"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.0ec826bc210a9cc536ee0476fb410a7a.svg";
export { ForwardRef as ReactComponent };